import { useContext } from 'react'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { Country } from 'shared/types/general.types'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchCountries = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const fetchCountries = () =>
		axiosPrivate
			.options('/settings/')
			.then((res) => res?.data?.actions?.PUT?.address?.children?.country?.choices)

	const { data: countries, isLoading: isCountriesLoading } = useQuery<Country[]>({
		queryKey: queryKeys.countries.all,
		queryFn: fetchCountries,
		enabled: !!auth.accessToken
	})

	return {
		countries,
		isCountriesLoading
	}
}
